import React from "react";
import { NavBarThree } from "../components/Header";
import { FootBar } from "../components/Footer";
import { NotifFrame } from "../components/Component";
import { useQuery } from "@tanstack/react-query";
import { NotificationApi } from "../app/api/notification.api";


const notif = NotificationApi();


export function Notification()
{

    const fetchNotifications = async () => {
        const {data} = await notif.findAll();
        return data.data;
    };
                    
    const { data, error, isLoading } = useQuery({
        queryKey: ["notifications"],
        queryFn: fetchNotifications,
    }); 

    return(

        <div className="container-fluid">
            <div className="row"> 
                {/* *************************************************************** */}
                <div className="col-lg-12 sticky-top bg-light border-bottom">  <NavBarThree target={'repository'} />  </div>
                {/* ************************************************* */}
                <div className="col-md-12 bg-light sticky-top">  
                    <div className="row pt-5 d-flex justify-content-center">  
                        <div className="col-lg-10">  
                            <ul className="nav nav-tabs">
                                <li className="nav-item bg-ligh ">  <a className="nav-link text-muted" aria-current="page" href="/repertoires"> Mes repertoires </a> </li>
                                <li className="nav-item">  <a className="nav-link text-muted" href="/repertoires-partages"> Partages </a> </li>
                                <li className="nav-item">  <a className="nav-link color-gren active" href="/notifications"> Notifications </a> </li>
                            </ul>
                        </div>
                    </div>
                </div> 
                {/* ************************************************* */}
                <div className="col-lg-12 py-5 bg-white min-h-80">  
                    <div className="row d-flex justify-content-center">  
                        <div className="col-lg-10">  
                            {/* -------------------------------------------------------- */}
                            {   (isLoading) ? ( <div className="d-flex justify-content-center p-5"> <div className="spinner-border text-success" style={{ width: "5rem", height: "5rem" }}  role="status" aria-label="Chargement"></div>  </div> ) : null }
                            {/* -------------------------------------------------------- */}
                            <div className="row"> 
                                {
                                    ( Array.isArray(data) && data.length > 0  ) ?    
                                    ( data.map( (item, index )=> (
                                        <div className="col-12 mb-4" key={index}>     
                                            <NotifFrame message={ item?.message } /> 
                                        </div>  
                                    ))
                                ) : (  ( Array.isArray(data) && data.length === 0  ) ? ( <div className="alert text-center alert-success"> <span className="text-muted"> Liste de répertoires vide </span> </div> ) : null )
                                }
                            </div> 
                            {/* -------------------------------------------------------- */}
                            {   (error) ? ( <div className="row d-flex justify-content-center p-5"> <div className="alert text-center alert-danger"> <span className="text-muted"> Erreur serveur interne </span> </div> </div> ) : null  } 
                            {/* -------------------------------------------------------- */} 
                        </div>  
                    </div>     
                </div> 
        
                {/* *************************************************************** */}
                <div className="col-lg-12 bg-dark">  <FootBar />  </div>
        
            </div>
        </div>  

    )
}